// Component part of the vehicle.
export class PartComponent {
    constructor(name: string, groupName: string, code: string) {
        this.name = name;
        this.groupName = groupName;
        this.code = code;
    }

    // Component code.
    public code: string;
    // Component name.
    public name: string;
    // Group name the component belongs to.
    public groupName: string;
}